module.exports = require('../../dist/writers/web-console.js')